export enum AgentEligibilityErrorType {
  NotEligibleToSellPolicyError = "NotEligibleToSellPolicyError",
  NotRequestedInNonJITStateError = "NotRequestedInNonJITStateError",
  RejectedInJITStateError = "RejectedInJITStateError",
  NotAppointedInNonJITStateError = "NotAppointedInNonJITStateError",
}
